module.exports = __webpack_public_path__ + "img/bank11.6b13d134.png";